import { MoneyCell } from '@ayocore/platform/client/components/EditableGrid';
import type { SupplierQuoteColumnKey, SupplierQuoteLike, SupplierQuotePatch } from './types';

export const quotePriceColumn = MoneyCell<
  SupplierQuoteLike,
  SupplierQuotePatch,
  SupplierQuoteColumnKey
>({
  key: 'price',
  title: 'Цена',
  width: 100,
});
